// Это будет умная кнопка, которая копирует email в буфер обмена, показывает подсказку при наведении и меняет свой вид на "Скопировано!" после клика.

'use client';

import { useState } from 'react';
import { Mail, Check } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/app/components/ui/tooltip';
import { cn } from '@/app/lib/utils';
import toast from 'react-hot-toast';

interface CopyEmailButtonProps {
  email: string;
  isPrimary?: boolean; // Добавляем флаг для стилизации
}

export function CopyEmailButton({ email, isPrimary = false }: CopyEmailButtonProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setIsCopied(true);
      toast.success('Email скопирован!');
      setTimeout(() => setIsCopied(false), 2000); // Сбрасываем состояние через 2 секунды
    }).catch(() => {
      toast.error('Не удалось скопировать.');
    });
  };

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={handleCopy}
            // ✅ Стилизуем кнопку в зависимости от флага isPrimary
            className={cn(
              "w-full inline-flex items-center justify-center gap-2 px-4 py-2 font-semibold rounded-lg transition-all duration-200",
              isPrimary 
                ? "bg-sky-600 hover:bg-sky-700 text-white" 
                : "bg-slate-700 hover:bg-slate-600 text-white",
              isCopied && "!bg-green-600" // Стиль при успешном копировании
            )}
          >
            {isCopied ? <Check size={18} /> : <Mail size={18} />}
            <span>{isCopied ? 'Скопировано!' : email}</span>
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Нажмите, чтобы скопировать email</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
